import { createSlice } from "@reduxjs/toolkit";
import { pending_programmes } from "../../../types/core_ibass";

export const pendingDelists = createSlice({
  name: "pending_delists",
  initialState: {
    value: {
      status: false,
      pagination: [] as {
        pagination_data: {
          current_page: number;
          last_page: number;
          per_page: number;
          total: number;
          from: number;
          to: number;
        };
        data: pending_programmes;
      }[],
      data: [] as pending_programmes,
    },
  },
  reducers: {
    update_pending_delists: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload?.data;
    },
    add_pending_delists: (state, action) => {
      state.value.data = [...state.value.data, action?.payload];
    },
    addToPendingPaginationHistory: (state, action) => {
      state.value.pagination = [
        ...state.value.pagination,
        {
          pagination_data: action?.payload?.pagination_data,
          data: action?.payload?.data,
        },
      ];
    },
    remove_pending_delists: (state, action) => {
      const { id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => Number(v.id) === id
      );
      if (currentIndex > -1) {
        currentArray.splice(currentIndex, 1);
        state.value.data = currentArray;
      }
    },
    replace_pending_delists: (state, action) => {
      const { id } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );
      currentArray.splice(currentIndex, 1, action?.payload);
      state.value.data = currentArray;
    },
    clear_pending_delists: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  update_pending_delists,
  add_pending_delists,
  addToPendingPaginationHistory,
  remove_pending_delists,
  replace_pending_delists,
  clear_pending_delists,
} = pendingDelists.actions;

export default pendingDelists.reducer;
